import { common as unauthenticatedSharedCommon } from "@unauthenticated/shared/locales/en/US/common";

const common = {
  ...unauthenticatedSharedCommon,
  header: {
    logoText: "Making the move from",
    title: "Your all-in-one account is waiting",
    content:
      "Connecting your Wellevate account to Fullscript is fast and easy to do. Just sign in using your Fullscript credentials, and we'll do the rest!",
    subContent:
      "Once complete, you'll be able to see all of your {{treatmentPlanTermPlural}}, order history, and favorite products in one place.",
  },
  signUpHeader: {
    logoText: "Making the move from",
    title: "Join {{- practitionerName}} on Fullscript",
    content:
      "Set a password to activate your account and join {{- practitionerName}} on Fullscript. You'll get the best value for high-quality supplements, delivered to your door.",
    subContent:
      "Transferring your Wellevate account to Fullscript is fast, easy, and secure - start by setting a new password. Once complete, you can order from your existing Wellevate recommendations, order history, and favorite products directly in Fullscript.",
  },
  expiredTokenMessage: {
    title: "Please check your email inbox",
    subTitle: "An email has been sent to {{patientEmail}} from Fullscript",
    content:
      "Click the button in the email to finish setting up your account.<1></1><2></2>Didn't get an email? It may be in your SPAM folder. If not, click below to resend.",
  },
  emailCapture: {
    title: "Connect your Wellevate account to Fullscript",
    subTitle: "Confirm the email you use with your Wellevate account",
    ctaText: "Continue",
    emailLabel: "Enter Wellevate email",
  },
  ineligibleMessage: {
    header: "isn’t eligible to connect",
    content1:
      "This may be because you’ve entered an incorrect email address. Make sure you’re using the email associated with your Wellevate account.",
    content2:
      "If you’re sure the email address entered is correct, it's likely that your practitioner hasn’t moved to Fullscript yet. You’ll need to wait until they do so. We’ll notify you when the time comes!",
    button: "Try again",
  },
  resendEmail: "Resend email",
  resentEmailSuccess: "Resent email successfully!",
  resentEmailMessage: "Still haven't received an email? <1>Contact us</1>",

  // TreatmentPlan Terms
  prescription: "prescription",
  prescription_plural: "prescriptions",
  prescription_capitalized: "Prescription",
  prescription_capitalized_plural: "Prescriptions",
  prescription_past_participle: "prescribed",
  prescription_past_participle_capitalized: "Prescribed",

  // Recommendation Terms
  recommendation: "recommendation",
  recommendation_plural: "recommendations",
  recommendation_capitalized: "Recommendation",
  recommendation_capitalized_plural: "Recommendations",
  recommendation_past_participle: "recommended",
  recommendation_past_participle_capitalized: "Recommended",
} as const;

export { common };
